import { useQuery } from '@apollo/client'
import { getInitiativeList as getInitiativeListGql }
   from 'src/graphql/queries/getInitiativeList.gql'

const useInitiativeList = (variables, options) => {
   const { data, error, ...otherQueryReturnValues } = useQuery(getInitiativeListGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      errorPolicy: 'all',
      ...options
   })

   const hasFatalErrors = error?.networkError ||
      error?.graphQLErrors?.some(err => err?.extensions?.exception?.name !== 'NonFatal')

   if (hasFatalErrors) {
      throw error
   }

   return {
      ...otherQueryReturnValues,
      error,
      initiativeList: data
         ? data.initiativeList
         : { items: [], listInfo: {} }
   }
}

export default useInitiativeList
